import { h } from 'preact';
export const ChevronsRight = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("polyline", { points: "13 17 18 12 13 7" }),
        h("polyline", { points: "6 17 11 12 6 7" })));
};
//# sourceMappingURL=chevrons-right.js.map